import RouteTemplate from 'ember-route-template';

import { concat } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import LinksTo from 'ember-route-state/components/links-to.gjs';
import { pageTitle } from 'ember-page-title';

import ReloadModel from 'rise-ui/components/reload-model.gjs';
import helpPagesSort from 'rise-ui/helpers/help-pages-sort.js';

export default RouteTemplate(class HelpSearchIndexTemplate extends Component {
  @service helpSearch;

  <template>
    {{pageTitle (if this.helpSearch.topic
      (concat this.helpSearch.topicName " | Help")
        "Help Search"
      )
    }}

    <h3 class="c-page-title qa-page-title">Search{{if this.helpSearch.topic (concat ": " this.helpSearch.topicName)}}</h3>

    {{#if @model.helpPages.isRejected}}
      <span class="c-no-result">Error searching help. <ReloadModel>Retry</ReloadModel></span>
    {{else if @model.helpPages.isPending}}
      <span class="c-no-result">Loading...</span>
    {{else}}
      {{#each (helpPagesSort @model.helpPages @model.helpPages.terms) as | helpPage |}}
        <div class="c-media">
          <div class="c-media__body">
            <div class="c-media__head">
              <h4 class="c-media__title">
                <LinksTo @route="help.page" @model={{helpPage.id}}>{{helpPage.title}}</LinksTo>
              </h4>
            </div>
            <div class="c-media__content">
              {{helpPage.bodySummary}}
            </div>
          </div>
        </div>
      {{else}}
        <span class="c-no-result">
          No matching help pages found. Please search again with different terms
          or <LinksTo @route="contact">contact us</LinksTo> for assistance.
        </span>
      {{/each}}
    {{/if}}

    {{outlet}}
  </template>
});
